module.exports = __webpack_public_path__ + "img/zuijia_33.8a75d9aa.png";